import classes from '@/components/Shares/Button.module.css';
import { Icons } from '@/components/Shares/Icons';
import { MODAL, useModalAction } from '@/providers/ModalActionProvider';
import { useLingui } from '@lingui/react';
import { Button, Flex } from '@mantine/core';
export const EquipButton: React.FC = () => {
  const {
    i18n
  } = useLingui();
  const {
    setOpenModal
  } = useModalAction();
  const handleOpenModal = () => {
    setOpenModal(MODAL.BUNKER);
  };
  return <Flex justify={{
    base: 'center',
    md: 'end'
  }}>
      <Button h={46} onClick={handleOpenModal} w={{
      base: '100%',
      xl: '70%'
    }} classNames={{
      root: classes.root
    }} leftSection={<Icons className="icon-pr-line-log-in" fontSize={20} fw={700} />}>
        {i18n._('Equip in bunker')}
      </Button>
    </Flex>;
};